export class Token {
  constructor(readonly value: string) {}

  get bearer(): string {
    return `Bearer ${this.value}`;
  }
}
